import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import React, { useState, useMemo, useEffect } from "react";
import "./ContactUs.css";
import { useWindowSize } from "@uidotdev/usehooks";
import { getImageLink, preloadImages } from "../common/functions";
import { branchDetails } from "../api";

const StoreLocator = () => {
  const imageUrls = [getImageLink("/assets/models/Food.jpg")];
  preloadImages(imageUrls);

  const size = useWindowSize();
  const [states, setStates] = useState([
    {
      name: "Gujarat",
      state_code: "GJ",
    },
  ]);
  // const [selectedState, setSelectedState] = useState(null);
  const [cities, setCities] = useState([
    "Ahmedabad",
    "Navsari",
    "Rajkot",
    "Surat",
    "Vadodara",
  ]);

  const [selectedCity, setSelectedCity] = useState(null);
  const [selectedArea, setSelectedArea] = useState(null);
  const [branchList, setBranchList] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    branchDetails
      .get()
      .then(res => {
        console.log("Branch Details API Response:", res.data);
        const branches = res.data?.data || [];
        // Map API response to match the expected structure (key -> id)
        const mappedBranches = branches.map(branch => ({
          ...branch,
          id: branch.key || branch.id, // Use key as id for compatibility
        }));
        setBranchList(mappedBranches);
        setLoading(false);
      })
      .catch(err => {
        console.error("Error fetching branch details:", err);
        setLoading(false);
      });
  }, []);

  // Generate area list grouped by city from branchList
  const getAreaList = useMemo(() => {
    if (!selectedCity || loading) return [];
    return branchList
      .filter(branch => branch.city === selectedCity)
      .map(branch => branch.id || branch.key);
  }, [selectedCity, branchList, loading]);

  const handleChangeArea = e => {
    const value = e.target.value;
    const data = branchList.find(v => v.id === value);
    setSelectedArea(data);
  };

  return (
    <Box my='3rem' className='contact-us main-background-image'>
      <Box fontWeight={500} className='content' m='2vw' textAlign='justify'>
        <p style={{ textAlign: "justify" }}>
          <strong>
            Thank you for choosing "Chatpata: Khao - Piyo - Aish Karo..."
          </strong>
        </p>
        <p style={{ textAlign: "justify" }}>
          We can't wait to serve you and create lasting flavour memories
          together. Come join us at one of our locations and embark on a
          culinary adventure that will leave you saying,
        </p>
        <p className='title-color tex-center' style={{ fontWeight: "bold" }}>
          "That was Chatpata - Khaya - Piya - Aish Kiya ..."{" "}
        </p>
      </Box>
      <Box width='100%'>
        <Box m={2} p={3} className='content box text-center'>
          <img
            style={{
              border: "1px solid black",
              padding: "20px",
              borderRadius: "10px",
              boxShadow: "1px 1px 4px 1px gray",
              maxWidth: "400px",
              width: "70vw",
            }}
            src={getImageLink("/assets/models/Food.jpg")}
            alt='food express'
          />

          <Typography
            className='title-color'
            fontWeight={500}
            my={4}
            style={{ marginBottom: "2rem" }}
            variant='h5'
            gutterBottom
          >
            Locate Your Nearest CHATPATA
          </Typography>
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              gap: "20px",
              justifyContent: "space-evenly",
            }}
          >
            <FormControl sx={{ minWidth: "150px", width: "30%" }}>
              <InputLabel id='demo-simple-select-label-1'>State</InputLabel>
              <Select
                labelId='demo-simple-select-label-1'
                id='demo-simple-select-1'
                value={states[0].name || ""}
                label='State'
                // onChange={handleStateChange}
              >
                {states.map((value, index) => (
                  <MenuItem key={index} value={value.name}>
                    {value.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl sx={{ minWidth: "150px", width: "30%" }}>
              <InputLabel id='demo-simple-select-label-2'>City</InputLabel>
              <Select
                labelId='demo-simple-select-label-2'
                id='demo-simple-select-2'
                value={selectedCity || ""}
                label='City'
                onChange={e => setSelectedCity(e.target.value)}
              >
                {cities.map((value, index) => (
                  <MenuItem key={index} value={value}>
                    {value}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl sx={{ minWidth: "150px", width: "30%" }}>
              <InputLabel id='demo-simple-select-label-3'>Store</InputLabel>
              <Select
                labelId='demo-simple-select-label-3'
                id='demo-simple-select'
                value={selectedArea?.id || ""}
                label='Store'
                onChange={handleChangeArea}
              >
                {getAreaList.map((value, index) => (
                  <MenuItem key={index} value={value}>
                    {value}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
        </Box>
        {selectedArea ? (
          <Box m={2} p={3} className='content box text-center'>
            <Typography
              fontWeight={500}
              className='title-color'
              variant='h5'
              gutterBottom
            >
              {selectedArea.name}
            </Typography>
            <Box display='flex' justifyContent='center'>
              <Box maxWidth={600}>
                {selectedArea.managedBy && (
                  <p style={{ textAlign: "center" }}>
                    {selectedArea.managedBy}
                  </p>
                )}
                <p>{selectedArea.address}</p>
                <p style={{ textAlign: "center" }}>
                  <strong>Contact: {selectedArea.contact}</strong>
                </p>
              </Box>
            </Box>
            <Box my={5} display='flex' justifyContent='center'>
              <div class='mapouter'>
                <div class='gmap_canvas'>
                  <iframe
                    width={size.width - 100}
                    style={{ maxWidth: "820px" }}
                    height='560'
                    id='gmap_canvas'
                    src={selectedArea.map}
                    frameborder='0'
                    scrolling='no'
                    marginheight='0'
                    marginwidth='0'
                  ></iframe>
                  <a href='https://timenowin.net/'>online clock</a>
                  <br />
                  <a href='https://www.clock-alarm.com/'></a>
                  <br />
                  <a href='https://www.ongooglemaps.com'>
                    embedding maps in website
                  </a>
                </div>
              </div>
            </Box>
          </Box>
        ) : (
          <Box sx={{ height: "30vh" }}></Box>
        )}
      </Box>
    </Box>
  );
};

export default StoreLocator;
